import {Aide} from '../api/Aide';
import {AideTranslation} from '../api/AideTranslation';
import {ExDossier} from './ex-dossier';

// A ne pas supprimer est utilisé dans une classe des dossiers
// @todo : 28/02 : sûr ? je ne vois aucun import
export class ExAideStatut {
    public code = 0; //0 - 1
    public label = 'Clos';
}

export class ExAide extends Aide {

    public userHasAlreadyCandidatureForThisAide = false;
    public userCandidatureForThisAide: ExDossier = null;

    public userCanUploadAnnexe = false;

    constructor(options = null) {
        super();
        if (options) {
            Object.assign(this, options);
        }

        if (this.translations == null || !this.translations.length) {
            this.translations = [
                new AideTranslation({
                    locale: 'fr',
                    commentaire: '',
                    preRequis: '',
                    notice: null,
                }),
                new AideTranslation({
                    locale: 'en',
                    commentaire: '',
                    preRequis: '',
                    notice: null,
                }),
            ];
        }

        if (this.aideFormulaires == null) {
            this.aideFormulaires = [];
        }
        if (this.utilisateurAutorises == null) {
            this.utilisateurAutorises = [];
        }

        this.initializeUserCanUploadAnnexe();
    }

    //Permet de set le sousType à partir de la liste des SousType passé en paramètres
    public setAideSousType(sousType: any[]) {
        if (this.aideSousType != null && typeof this.aideSousType == 'string') {
            this.aideSousType = sousType.find(item => item['@id'] === this.aideSousType);
        }
    }

    public getTranslation(key, locale) {
        let str = '';
        if (this.translations != null && this.translations.length) {
            this.translations.map(item => {
                if (item.locale === locale && item[key]) {
                    str = item[key];
                }
            });
        }
        return str;
    }

    public initializeUserCanUploadAnnexe(): boolean {
        let dateLimiteEnvoiAnnexes: any = null;

        if (this.dateFinUploadAnnexes) {
            dateLimiteEnvoiAnnexes = new Date(this.dateFinUploadAnnexes);
        }

        if (dateLimiteEnvoiAnnexes) {
            dateLimiteEnvoiAnnexes.setHours(24, 0, 0, 0);
            if (dateLimiteEnvoiAnnexes > new Date()) {
                this.userCanUploadAnnexe = true;
            }
        } else {
            this.userCanUploadAnnexe = true;
        }

        return this.userCanUploadAnnexe;
    }

    public hasCommissionSeanceDecisive(): boolean {
        if (!this.commissionSeances) {
            return false;
        }
        return this.commissionSeances.find(item => item.decisiveStatutDossier) !== undefined;
    }

    public hasCommissionSeanceSuivi(): boolean {
        if (!this.commissionSeances) {
            return false;
        }
        return this.commissionSeances.find(
            (item) => {
                if (!item.commission) {
                    return false;
                }
                return item.commission.code === 'SDEC';
            }
        ) !== undefined;

    }

    public estDebute(): boolean
    {
        if(!this.dateDebutSaisie){
            return false;
        }
        return new Date() > new Date(this.dateDebutSaisie);
    }

    public estClos(): boolean
    {
        if(!this.dateFinSaisie){
            return false;
        }
        return new Date() > new Date(this.dateFinSaisie);
    }
}
